import React from 'react'

import {
  StyledDropDownButton,
  ButtonText,
  Main,
  ActionMenu,
  ItemText,
} from 'components/ActionStyles/ActionStyles'
import DownArrow from 'components/icons/DownArrow'
import { StyledButton } from '../../../../../components/ActionStyles/ActionStyles'

const ActionDropdown = ({
  rowData,
  setViewUserDrawer,
  getSingleUserInfo,
  setAddUserDrawer,
  setUserId,
  updateUserStatus,
  deleteUser,
  getUserData,
  cruds,
  inActiveTemplate,
  sendNotificationEmail,
  activeTemplate,
}) => {
  const onClickView = rowId => {
    setViewUserDrawer(true)
    getSingleUserInfo(rowId)
  }

  const onClickEdit = rowData => {
    setAddUserDrawer(true)
    setUserId(rowData?._id)
    getSingleUserInfo(rowData?._id)
  }



  const onUpdateStatus = async status => {
    let response = await updateUserStatus({
      userId: rowData?._id,
      status: status,
    })
    if (response?.status >= 200 && response?.status <= 300) {
      if (!status && inActiveTemplate) {
        let name = rowData?.first_name + ' ' + rowData?.last_name
        let template
        template = inActiveTemplate?.templateText.replace('{UserName}', name)
        let mailObj = {
          to: rowData?.email,
          subject:
            inActiveTemplate?.subject ||
            'Your Account  is Inactive - Pluginlive',
          htmlBody: template,
        }
        sendNotificationEmail(mailObj)
      }
      if (status && activeTemplate) {
        let name = rowData?.first_name + ' ' + rowData?.last_name
        let template
        template = activeTemplate?.templateText.replace('{UserName}', name)
        let mailObj = {
          to: rowData?.email,
          subject:
            activeTemplate?.subject ||
            'Your Account  is Activated - Pluginlive',
          htmlBody: template,
        }
        sendNotificationEmail(mailObj)
      }
      getUserData()
    }
  }
  let menuItems = [
    {
      hidden: !cruds?.includes('EDIT'),
      key: 'edit',
      label: <ItemText onClick={() => onClickEdit(rowData)}>Edit</ItemText>,
    },
    rowData?.is_active
      ? {
          hidden: !cruds?.includes('ACTIVE/INACTIVE'),

          key: 'inactive',

          label: 'Set to Inactive',
          onClick: item => {
            onUpdateStatus(false)
          },
        }
      : {
          key: 'active',
          hidden: !cruds?.includes('ACTIVE/INACTIVE'),
          label: 'Set to Active',
          onClick: item => {
            onUpdateStatus(true)
          },
        },
//Future Use
    // {
    //   hidden: !cruds?.includes('DELETE'),

    //   type: 'divider',
    // },
    // {
    //   key: 'delete',
    //   hidden: !cruds?.includes('DELETE'),
    //   label: (
    //     <ItemDeleteText onClick={() => onDelete()}>Delete User</ItemDeleteText>
    //   ),
    // },
  ].filter(item => !item.hidden)
  const menu = <ActionMenu width={'165px'} items={menuItems} />
  return (
    <Main id="FilterDropdown">
      {menuItems?.length ? (
        <StyledDropDownButton
          overlay={menu}
          shape="round"
          onClick={() => onClickView(rowData?._id)}
          trigger={['click']}
          icon={<DownArrow />}
          getPopupContainer={() => document.getElementById('FilterDropdown')}
        >
          <ButtonText>View</ButtonText>
        </StyledDropDownButton>
      ) : (
        <StyledButton onClick={() => onClickView(rowData?._id)}>
          View
        </StyledButton>
      )}
    </Main>
  )
}

export default ActionDropdown
